import type {Dayjs} from 'dayjs'

export const roundMinutes = (time: Dayjs, direction: 'up' | 'down' | 'closest' = 'closest'): Dayjs => {
  const minute = time.get('minute')

  let minutesToAdd = 0
  switch (direction) {
    case 'up':
      minutesToAdd = Math.ceil(minute / 15) * 15
      break
    case 'down':
      minutesToAdd = Math.floor(minute / 15) * 15
      break
    case 'closest':
      minutesToAdd = Math.round(minute / 15) * 15
      break
  }

  return time.startOf('hour').add(minutesToAdd, 'minutes')
}
